module.exports = __webpack_public_path__ + "static/media/1.6dc96543.jpg";